import http from "@/common/http-common";
import store from "@/store";

class CountryService {
  async loadAll() {
    return http().get("/api/v1/countries.json").then(function(resp) {
      console.log("Inside CountryService.loadAll, resp.data ==> ", resp.data);
      store.commit("updateCountries", resp.data);
    })
  }
}

export default new CountryService();